import React from 'react';
import Reveal from '../components/Reveal';
import { GmailIcon, WhatsAppIcon } from '../components/ContactIcons';

const contactMethods = [
  {
    label: 'Email',
    value: 's4cocoexports@gmail.com',
    helper: 'For product, pricing, documentation, and export coordination.',
    href: 'mailto:s4cocoexports@gmail.com',
    icon: GmailIcon
  },
  {
    label: 'WhatsApp',
    value: '+91 6383860220',
    helper: 'Fast response for buyer requirements and shipment discussions.',
    href: 'https://wa.me/916383860220',
    icon: WhatsAppIcon
  },
  {
    label: 'Phone',
    value: '+91 9488224658',
    helper: 'Call for direct export inquiries and business communication.',
    href: 'tel:+919488224658'
  }
];

const ContactPage = () => {
  return (
    <main>
      <section className="page-heading">
        <div className="container-custom">
          <Reveal>
            <p className="eyebrow-pill mb-5">Contact</p>
            <h1 className="page-title">Connect directly with S4CoconutExports.</h1>
            <p className="page-intro">
              Use email, WhatsApp, or phone to share your product requirement, destination, quantity, packaging expectation, and shipment timeline.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="page-section">
        <div className="container-custom">
          <div className="contact-conversion">
            <Reveal>
              <aside className="contact-panel">
                <p className="eyebrow-pill mb-5">Buyer guidance</p>
                <h2>Send the details that help us respond clearly.</h2>
                <ul>
                  <li>Product type and target specification</li>
                  <li>Destination country or port</li>
                  <li>Estimated order volume or recurring need</li>
                  <li>Preferred packing and shipment timeline</li>
                </ul>
                <p className="contact-trust-note">
                  A clear requirement helps the team respond with suitable product, packing, and export details.
                </p>
              </aside>
            </Reveal>

            <Reveal delay={140}>
              <div className="contact-direct-list">
                {contactMethods.map((method) => (
                  <a key={method.label} className="contact-direct-card" href={method.href} target={method.label === 'WhatsApp' ? '_blank' : undefined} rel={method.label === 'WhatsApp' ? 'noreferrer' : undefined}>
                    <method.icon className="contact-method-icon" />
                    <span>{method.label}</span>
                    <strong>{method.value}</strong>
                    <p>{method.helper}</p>
                  </a>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
